import { Button, Typography } from '@mui/material';
import { sortBy } from 'lodash';
import { useEffect, useState } from 'react';

import { useProgress } from '@/contexts/ProgressProvider';
import VnModalBody from '@/modals/components/VnModalBody';
import VnModalFooter from '@/modals/components/VnModalFooter';
import { useModalContext } from '@/modals/VNModalProvider';

import type { Item, Job } from '../../../models';
import { TranscodeJobManagerService } from '../../../services/transcode-job-manager-service';
import useAppUtils from '../../../utils/appUtils';
import clientUtils from '../../../utils/clientUtils';
import type { ResubmitStatus } from './intake-steps-table/IntakeStepsTable';
import IntakeStepsTable from './intake-steps-table/IntakeStepsTable';

interface IPros {
  asset: Item;
  // form:any;
  // onSave:(form: any) => void;
}
const IntakeModal = ({ asset }: IPros) => {
  const [jobs, setJobs] = useState([]);
  const { alert } = useAppUtils();
  const [resubmitStatuses, setResubmitStatuses] = useState<{ [key: string]: ResubmitStatus }>({});
  const [isInitialized, setIsInitialized] = useState(false);
  const { loading, setProgress } = useProgress();
  const { onClose } = useModalContext();

  const handleClose = () => {
    // setOpen(false);
    setResubmitStatuses({});
    setJobs([]);
    onClose();
  };

  const init = async () => {
    setProgress(true);
    const { id } = asset;
    try {
      const jobsResponse = await TranscodeJobManagerService.fetchJobs(id);
      // console.log(jobsResponse)
      const jobs = sortBy(jobsResponse, [
        (job: Job) => {
          return job.lastUpdated;
        },
      ]);
      setJobs(jobs);
    } catch (ex) {
      // console.log('Unable to fetch jobs');
    } finally {
      setProgress(false);
      setIsInitialized(true);
    }
  };

  const copyJobGroupId = () => {
    if (jobs.length > 0) {
      clientUtils.copyToClipboard(jobs[0].jobGroupId);
      alert('Job Group ID' + ' copied to clipboard!');
    }
  };

  const onResubmitJob = async (job: Job) => {
    setResubmitStatuses({ ...resubmitStatuses, [job.jobId]: 'submitted' });
    try {
      const message = await TranscodeJobManagerService.restartJob(job.jobId);
      alert(message);
    } catch (ex) {
      setResubmitStatuses({ ...resubmitStatuses, [job.jobId]: 'error' });
    }
  };

  useEffect(() => {
    if (asset) {
      setProgress(true);
      init();
    }
    return () => { };
  }, [asset]);

  return (
    <div>
      <VnModalBody>
        {isInitialized && jobs.length === 0 && (
          <Typography>
            Ingest steps are not available for this asset.
            <br />
            <br />
            Please contact support if you are experiencing difficulties utilizing this asset.
          </Typography>
        )}
        {!loading && jobs.length > 0 && (
          <IntakeStepsTable jobs={jobs} onResubmitJob={onResubmitJob} resubmitStatuses={resubmitStatuses} />
        )}
      </VnModalBody>
      <VnModalFooter
        right={
          <Button autoFocus variant="contained" className="cancel-button" onClick={handleClose}>
            Close
          </Button>
        }
      />
    </div>
  );
};

export default IntakeModal;
